export const PLAYER_CONTAINER_CLASS = 'netplayer-container';
